import { render, staticRenderFns } from "./dangan.vue?vue&type=template&id=90178fe8"
import script from "./dangan.vue?vue&type=script&lang=ts"
export * from "./dangan.vue?vue&type=script&lang=ts"
import style0 from "./dangan.vue?vue&type=style&index=0&id=90178fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports